import { render } from "./NoUrlDashboard.vue?vue&type=template&id=6b0a6289"
import script from "./NoUrlDashboard.vue?vue&type=script&lang=js"
export * from "./NoUrlDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__